module.exports = __webpack_public_path__ + "files/d5c35ad4a52fed90aec7d2b7116d85d7.png";